import styled from 'styled-components';

export const ModalMenuList = styled.ul`
  width: 100%;
  list-style: none;
  max-height: 60vh;
  min-height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: block;
`;
